import React from 'react';
import styles from './RatingCircle.module.css';

const RatingCircle = ({ rating = 8.8 }) => {
    const segments = 50; // More segments for a smoother look
    const totalAngle = 360; // Narrow 20 degree gap at top
    const numericRating = Math.min(10, Math.max(0, parseFloat(rating) || 0));
    const activeSegments = Math.round((numericRating / 10) * segments);

    return (
        <div className={styles['rating-circle-container']}>
            <svg viewBox="0 0 200 200" className={styles['rating-svg']}>
                <defs>
                    <filter id="goldGlowBar" x="-100%" y="-100%" width="300%" height="300%">
                        <feGaussianBlur stdDeviation="1" result="blur" />
                        <feFlood floodColor="#E1A84B" floodOpacity="1" result="color" />
                        <feComposite in="color" in2="blur" operator="in" result="glow" />
                        <feMerge>
                            <feMergeNode in="glow" />
                            <feMergeNode in="glow" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                </defs>

                {[...Array(segments)].map((_, i) => {
                    // Start exactly at 12 o'clock (-90 degrees)
                    const angle = 0 + (i * totalAngle) / segments;
                    const isActive = i < activeSegments;

                    return (
                        <rect
                            key={i}
                            x="97.5"
                            y="8"
                            width="5"
                            height="28"
                            rx="2.5"
                            fill={isActive ? "#FFCC00" : "#333"}
                            filter={isActive ? "url(#goldGlowBar)" : "none"}
                            style={{
                                transform: `rotate(${angle}deg)`,
                                transformOrigin: '100px 100px',
                                opacity: isActive ? 1 : 0.5,
                                filter: isActive ? 'drop-shadow(0 0 5px #E2A94C)' : 'none',
                                transition: `all 0.5s ease ${i * 0.01}s`
                            }}
                        />
                    );
                })}
            </svg>
            <div className={styles['rating-text-overlay']}>
                <span className={styles['rating-number']}>{rating}</span>
                <span className={styles['rating-denom']}>/10</span>
            </div>
        </div>
    );
};

export default RatingCircle;
